import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Box, Divider, FormControl, Menu, MenuItem, Select, Stack } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";

import { useLabels } from "api/services/useLabels";
import { Typography } from "new-components/typography/Typography";
import { ListResponse } from "types/api";
import { Detector } from "types/detectors";
import { ImageQuery } from "types/imageQueries";
import { flaggedFilter, redirectToDataPage } from "utils/redirectDataPage";

interface FlaggedMenuProps {
  getPosichecks: (route?: string | undefined) => Promise<ListResponse<ImageQuery>>;
  handleChangeOrdering: (value: string) => void;
  setLoading: (value: boolean) => void;
  orderingParam: string;
  detector: Detector | undefined;
  showPosichecks?: number;
}

const options = [
  { name: "Most Recent (Created Date)", value: "-created_at" },
  { name: "Oldest First (Created Date)", value: "created_at" },
  { name: "Reason Marked Unclear", value: "label_feedback_text" },
];

export function FlaggedMenu(props: FlaggedMenuProps) {
  const { getPosichecks, handleChangeOrdering, orderingParam, detector, showPosichecks, setLoading } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuIsOpen = Boolean(anchorEl);

  const { acceptUnclearLabelsAsync } = useLabels();

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAcceptAll = () => {
    setLoading(true);
    try {
      acceptUnclearLabelsAsync({
        detector_id: detector?.id || "",
      })
        .then(() => {
          getPosichecks().then(() => {
            setLoading(false);
          });
        })
        .finally(() => {
          handleMenuClose();
        });
    } catch (error) {
      console.error("Error in handleAcceptAll:", error);
    } finally {
      setLoading(false);
    }
  };

  return showPosichecks ? (
    <Stack
      direction="row"
      divider={<Divider orientation="vertical" flexItem />}
      spacing={2}
      className="mt-4 items-center"
    >
      <FormControl className="w-full">
        <Box sx={{ padding: "1px 0px" }} className="flex justify-between items-center gap-2">
          <Box>
            <Typography noWrap>Sort By:</Typography>
          </Box>
          <Select
            id="demo-simple-order-select"
            value={orderingParam}
            onChange={(e) => handleChangeOrdering(e.target.value)}
            fullWidth
            displayEmpty
            sx={{ backgroundColor: "white" }}
          >
            {options.map((option) => (
              <MenuItem value={option.value} key={option.value}>
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </FormControl>

      <Box>
        <Box
          component="button"
          className="flex justify-between items-center bg-gray-200 p-2 rounded-md cursor-pointer"
          onClick={handleMenuOpen}
        >
          <MoreHorizIcon />
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={menuIsOpen}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            className: "w-[330px] mt-[8px] bg-neutral-200",
          }}
          MenuListProps={{
            className: "py-[5px]",
          }}
        >
          <Link to={`/reef/review/queue?detector_id=${detector?.id}&flagged=true`}>
            <MenuItem>Load All in Review View</MenuItem>
          </Link>
          <Link to={redirectToDataPage({ detectorId: detector?.id || "", filterOptions: flaggedFilter.unsure })}>
            <MenuItem>Load All in Data View</MenuItem>
          </Link>
          <MenuItem onClick={handleAcceptAll}>Dismiss all Flagged images</MenuItem>
        </Menu>
      </Box>
    </Stack>
  ) : null;
}
